import { OrderSettingModel } from "src/app/frontoffice/order/model/ordersetting.model";
import { EntityBase } from "./entity-base.model";

export class UserSettingModel extends EntityBase {
  public UserId: number;
  public DataValue: string;
}
export class LocalSettingModel extends EntityBase {
  public BookMarkMenu: BookMarkMenu[];
  public Language: string;
  public Theme: string;
  public SideMenuState: number;
  public isPinned: boolean;
  public UserId: number;
  public Isrtl: string;
  public OrderSetting: OrderSettingModel;
  constructor() {
    super();
    this.BookMarkMenu = [];
    this.isPinned = false;
    this.OrderSetting = new OrderSettingModel();
  }
}
export class BookMarkMenu extends EntityBase {
  public title: string;
  public icon: string;
  public selectedMenu: string;
  public selectedMenu1: string;
  public selectedMenu2: string;
  public selectedMenu3: string;
  public actionName: string;
}
